import { render, staticRenderFns } from "./PaymentNeopag.vue?vue&type=template&id=1f7a3695&"
import script from "./PaymentNeopag.vue?vue&type=script&lang=js&"
export * from "./PaymentNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports